import { render, staticRenderFns } from "./Diplomacy.vue?vue&type=template&id=6e20c464&scoped=true&"
import script from "./Diplomacy.vue?vue&type=script&lang=js&"
export * from "./Diplomacy.vue?vue&type=script&lang=js&"
import style0 from "./Diplomacy.vue?vue&type=style&index=0&id=6e20c464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20c464",
  null
  
)

export default component.exports